import { app } from '../../config';

// eslint-disable-next-line
export const getProductShareLink = (product) => {
    const { referrer, promotion } = product;

    const base64EncodeParam = window.btoa(`${referrer}:${promotion._id}`);
    return `${app.giftlyUrl}/r/${base64EncodeParam}`;
};
